export const INDUSTRY_TYPE = [
  { id: 'A', name: '农、林、牧、渔业' },
  { id: 'B', name: '采矿业' },
  { id: 'C', name: '制造业' },
  { id: 'D', name: '电力、热力、燃气及水生产和供应业' },
  { id: 'E', name: '建筑业' },
  { id: 'F', name: '批发和零售业' },
  { id: 'G', name: '交通运输、仓储和邮政业' },
  { id: 'H', name: '住宿和餐饮业' },
  { id: 'I', name: '信息传输、软件和信息技术服务业' },
  { id: 'J', name: '金融业' },
  { id: 'K', name: '房地产业' },
  { id: 'L', name: '租赁和商务服务业' },
  { id: 'M', name: '科学研究和技术服务业' },
  { id: 'N', name: '水利、环境和公共设施管理业' },
  { id: 'O', name: '居民服务、修理和其他服务业' },
  { id: 'P', name: '教育' },
  { id: 'Q', name: '卫生和社会工作' },
  { id: 'R', name: '文化、体育和娱乐业' },
  { id: 'S', name: '公共管理、社会保障和社会组织' },
  { id: 'T', name: '国际组织' },
  { id: '1000', name: '事业单位' }
];

export const OLD_INDUSTRY_TYPE = [
  { id: '1001', name: 'IT服务' },
  { id: '1002', name: '制造业' },
  { id: '1003', name: '批发/零售' },
  { id: '1004', name: '生活服务' },
  { id: '1005', name: '文化/体育/娱乐业' },
  { id: '1006', name: '建筑/房地产' },
  { id: '1007', name: '教育' },
  { id: '1008', name: '运输/物流/仓储' },
  { id: '1009', name: '医疗' },
  { id: '1010', name: '政府' },
  { id: '1011', name: '金融' },
  { id: '1012', name: '能源/采矿' },
  { id: '1013', name: '农林渔牧' },
  { id: '1014', name: '其他行业' },
  { id: '1000', name: '事业单位' }
];

export function getIndustryTypeStr(type) {
  // 1014 其它行业 在下拉框里不能选择 不展示 只在查看名称是展示
  const result = INDUSTRY_TYPE.find(item => item.id == type);
  if (result) {
    return result.name;
  } else if (type == '1014') {
    return '其他行业';
  } else {
    return type;
  }
  // 展示时兼容历史数据
  //const oldResult = OLD_INDUSTRY_TYPE.find(item => item.id == type);
  //return oldResult ? oldResult.name : type;
}
